import React from 'react';

export const LogoDarkIcelandia = () => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x={0}
    y={0}
    viewBox='0 0 1920 1080'
    // style={{
    //   background: 'new 0 0 1920 1080',
    // }}
    enableBackground={'new 0 0 1920 1080'}
    xmlSpace='preserve'
    //{...props}
  >
    <style>{'.st0{fill:#004a8e}.st4{fill:#00b39b}'}</style>
    <path
      className='st0'
      d='M1222.7 781.5V738h7.8v17.2c1.4-2.2 4.6-4 9-4 8.6 0 13.6 6.6 13.6 15.4 0 9-5.6 15.6-14 15.6-4 0-7.2-1.8-8.8-4.4v3.6h-7.6v.1zm15.2-23.3c-4 0-7.4 3-7.4 8.4s3.4 8.4 7.4 8.4 7.4-3 7.4-8.4c-.1-5.4-3.3-8.4-7.4-8.4zM1260 793.1l7-15.4-12.6-25.9h9l7.8 17.4 7.2-17.4h8.6l-18.6 41.3h-8.4zM1315.9 774.9l-4.6-18.6 2.7-18.6h10.2l-2.6 18.2 4.6 18.6-3.9 18.6h-10.2l3.8-18.2zM1332 765.4c0-16.8 10.8-28.8 26.2-28.8 12.3 0 21.5 7.6 23.8 19h-10.2c-2-5.9-7.1-9.8-13.6-9.8-9.6 0-16.4 8.1-16.4 19.5s6.8 19.5 16.4 19.5c6.5 0 11.5-3.8 13.5-9.5h10.3c-2.5 11.3-11.6 18.8-23.8 18.8-15.3.1-26.2-11.9-26.2-28.7zM1389.1 737.7h32.6v9.2h-22.8v16.8c6.6-2.9 13.9-4.5 21.7-4.5v9c-7.9 0-15.2 1.8-21.7 5.2V784h22.8v9.2h-32.6v-55.5zM1429.8 737.7h9.8v46.1h20.7v9.2h-30.5v-55.3zM1463.7 793.1l20.6-55.4h10.3l20.5 55.4H1505l-4.1-11.2c-9.8 1.5-19 5.3-27 11.2h-10.2zm34.1-19.6-8.4-23.2-10.8 29.7c6.1-3.2 12.5-5.4 19.2-6.5zM1520.8 737.7h11.8l24.5 40.4v-40.4h9.7v55.4H1555l-24.4-40.3v40.3h-9.8v-55.4zM1576.1 737.7h16.9c9.2 0 15.8 2.5 20.5 6.9 5.5 4.9 8.7 12.2 8.7 20.8 0 7.9-2.8 14.8-7.5 19.7-4.8 5-11.9 8-21.8 8H1576v-55.4zm16.2 46.2c7.3 0 12.2-2.2 15.4-5.7 2.9-3.3 4.7-7.7 4.7-12.8 0-5.8-2.2-10.5-5.8-13.8-3.2-2.8-7.5-4.6-14.2-4.6h-6.5v36.9h6.4zM1629 737.7h9.8v55.4h-9.8v-55.4zM1644.5 793.1l20.6-55.4h10.3l20.5 55.4h-10.2l-4.8-13.2-10.5 4.3-11.4-3.3-4.5 12.2h-10zm25.6-18.3 7.8-3.2-7.7-21.2-8.1 22.2 8 2.2zM782.9 385.6c9.6-2.2 24.2-3.5 38.6-3.5 13.7 0 27.9 2 38 7.9 9.4 5.5 16.1 13.9 16.1 26.7 0 20.4-14.2 33-32.8 38.7v.6c8.6 3.7 12.2 12.6 13.7 25.1 1.7 15.5 3 33.4 5.6 39.1h-31.8c-1.3-3.7-2.6-15.5-4.1-32.4-1.3-16.7-7.5-21.8-19.7-21.8h-9.4l-10.7 54.2h-30.5l27-134.6zm18.9 58.5h12.7c16.7 0 29-9.6 29-23 0-11-9.7-15.9-22.1-15.9-5.8 0-9.4.4-12 1l-7.6 37.9zM967.2 514.6c-12.2 5.9-27.5 7.9-39.1 7.9-30 0-45.5-16.1-45.5-42.2 0-30.4 23.2-61.9 61.2-61.9 21.2 0 36.5 11.4 36.5 29.9 0 25.3-26 34.4-68 33.4 0 2.9 1.1 7.3 3.2 10.2 4.1 5.1 11.2 7.7 20.2 7.7 11.4 0 21-2.4 29.4-6.3l2.1 21.3zm-15.9-66.4c0-4.9-4.3-8.4-11.4-8.4-14.4 0-22.5 11.4-24.7 20.6 24 .2 36-2.9 36-12v-.2zM1026 420.7l6.4 43.4c1.5 10.4 2.6 17.5 3.4 23.8h.4c2.4-6.1 4.5-12.6 9.2-23.4l19.1-43.8h32.6l-37.5 71.5c-14 26.5-26.4 44.6-40.3 57.1-12.2 11-26.8 15.9-33.7 16.9l-6.9-25.1c4.9-1.4 11.8-3.9 17.8-7.9 7.1-4.7 13.1-10.6 17.2-17.3.9-1.4.9-2.7.4-4.7l-20.6-90.5h32.5zM1093.6 520.3l29-144.6h30.7l-17.4 86.6h.4c3.2-3.9 6.4-7.7 9.4-11.2l26.8-30.4h38.2l-44.6 41.2 29.2 58.5h-34.5l-18.5-42.6-11.6 10.6-6.4 32h-30.7z'
    />
    <path
      className='st0'
      d='m1261.2 420.7-18.9 96.4c-3.4 17.1-7.9 27.9-14.8 35.3-6.9 7.3-17.8 10.6-28.5 10.6-4.7 0-10.1-.4-14.8-1.6l3.4-22c2.1.2 4.1.4 6.9.4 7.1 0 12.9-3.5 16.5-21.4l19.5-97.6h30.7zm-12.7-13.1c-9 0-15.7-6.1-15.7-15.3 0-10.6 8.8-17.7 18.9-17.7 9.7 0 16.5 5.9 16.5 15.3 0 11.2-9 17.7-19.5 17.7h-.2zM1335.7 520.3c.2-5.7.9-12.6 1.3-19.8h-.4c-9.9 16.5-23.4 22-35.6 22-18.9 0-31.8-13.9-31.8-34.6 0-33.6 23.6-69.5 75.1-69.5 12.7 0 26 2.2 34.6 4.9l-10.5 52.2c-2.6 12.8-4.7 32.4-4.3 44.8h-28.4zm8.3-78.8c-2.3-.4-4.9-.8-8.1-.8-20 0-34.5 23.2-34.5 41.8 0 9.8 4.1 16.5 12.7 16.5 9.2 0 21.2-10 25.8-34.4l4.1-23.1zM1424.1 420.7l4.9 43.6c1.3 12.2 2.1 19.8 2.8 27.1h.6c2.8-7.1 6-14.7 11.8-26.9l21-43.8h34.5l-58.4 99.6h-31.6l-17.6-99.6h32zM1495.1 520.3l19.9-99.6h30.7l-19.7 99.6h-30.9zm39.1-112.7c-9 0-15.7-6.1-15.7-15.3 0-10.6 8.8-17.7 18.9-17.7 9.7 0 16.5 5.9 16.5 15.3 0 11.2-9 17.7-19.5 17.7h-.2zM1552 520.3l29-144.6h30.7l-17.4 86.6h.4c3.2-3.9 6.4-7.7 9.4-11.2l26.8-30.4h38.2l-44.6 41.2 29.2 58.5h-34.6l-18.5-42.6-11.6 10.6-6.4 32H1552zM816.7 627.4h-51.3l-6.7 33.4h57.8l-5.2 25h-88.6l27.4-137.3h85.7l-5.2 25.1h-54.5l-6 29.1h51.7zM873.7 586.2l6.2 14.9c3.4 8 5.4 13 6.9 16.9h.6c3.6-5.5 6.7-10 11.2-16.1l11.6-15.7h35.4l-44.2 48.5 24.3 51.1h-33.9l-6.4-15.9c-3-7.1-4.9-12.2-6.9-18.1h-.6c-2.8 4.7-5.6 10-10.5 16.7l-12.7 17.3H819l45.5-51.5-24.7-48.1h33.9zM1016.2 682.8c-6.7 3.1-17.4 5.3-29.8 5.3-26 0-44.2-15.1-44.2-41 0-35.4 28.5-63.2 68.5-63.2 9 0 16.7 1.6 21.5 3.5l-7.7 22.4c-3.6-1.4-7.9-2.4-14.2-2.4-21.9 0-35.6 17.7-35.6 36.5 0 13.9 9.2 20.8 20.6 20.8 9 0 15.4-2 20.8-4.1l.1 22.2zM1146.1 586.2l-13.3 67.2c-2.6 12.6-4.3 23.4-5.8 32.4h-27.3l1.9-16.1-.4-.2c-10.7 13-23.4 18.5-36 18.5-17 0-27-9-27-27.9 0-5.3.9-11.4 2.1-18.3l11.2-55.6h30.9l-10.7 53.4c-.8 4.5-1.5 9.6-1.5 13.2 0 6.3 2.8 11.4 10.5 11.4 10.5 0 21.5-12 25.3-31.8l9.2-46.2h30.9zM1152.1 685.8l12-59.3c3-15.1 4.3-31.8 5.4-40.3h26.6c-.4 6.7-1.1 13.4-1.9 20.6h.9c7.3-13.5 18.9-22.8 33.3-22.8 2.1 0 4.1.2 5.8.2l-6 28.7c-1.3-.2-3-.2-4.7-.2-19.5 0-29 16.5-32.8 36.1l-7.3 37.1h-31.3zM1235.5 659.8c6 2.9 17.4 6.9 27.5 6.9 8.6 0 13.1-4.1 13.1-9s-3.4-8.3-13.1-12.8c-12-5.7-22.1-14.1-22.1-26.5 0-20.8 19.1-34.4 46.1-34.4 12.2 0 21.9 2.4 26.8 5.1l-7.3 20.8c-4.3-1.8-11.8-4.3-21-4.3-8.2 0-13.5 3.3-13.5 8.8 0 4.1 4.3 7.3 12.7 11.2 11.6 5.3 23.6 13.6 23.6 27.5 0 22.8-20.4 35.3-48.3 35-13.1-.2-25.8-3.5-32-7.7l7.5-20.6zM1320.9 685.8l19.9-99.6h30.7l-19.7 99.6h-30.9zm39.1-112.6c-9 0-15.7-6.1-15.7-15.3 0-10.6 8.8-17.7 18.9-17.7 9.7 0 16.5 5.9 16.5 15.3 0 11.2-9 17.7-19.5 17.7h-.2zM1425.6 688.1c-26.8 0-44.6-16.5-44.6-41.2 0-34.4 25.3-63 62.7-63 28.3 0 44.6 18.4 44.6 41.2 0 36.3-26.4 62.9-62.4 62.9h-.3zm4.1-22.4c16.7 0 26.4-23.4 26.4-40.3 0-9.4-4.3-18.9-16.5-18.9-17.8 0-26.8 24.4-26.8 39.9 0 11.6 6.2 19.3 16.7 19.3h.2zM1497.7 685.8l13.3-67.2c2.6-12.6 4.3-23.4 5.6-32.4h27.3l-1.9 16.5h.4c9.9-12.8 23-18.7 36.7-18.7 17.2 0 27.1 10 27.1 27.3 0 4.5-.7 11.8-1.7 16.7l-11.6 57.9H1562l10.9-55.2c.6-3.5 1.1-7.3 1.1-11 0-7.1-2.6-12-10.5-12-10.1 0-21.9 12-26.2 34l-8.6 44.2h-31zM1622.4 659.8c6 2.9 17.4 6.9 27.5 6.9 8.6 0 13.1-4.1 13.1-9s-3.4-8.3-13.1-12.8c-12-5.7-22.1-14.1-22.1-26.5 0-20.8 19.1-34.4 46.1-34.4 12.2 0 21.9 2.4 26.8 5.1l-7.3 20.8c-4.3-1.8-11.8-4.3-21-4.3-8.2 0-13.5 3.3-13.5 8.8 0 4.1 4.3 7.3 12.7 11.2 11.6 5.3 23.6 13.6 23.6 27.5 0 22.8-20.4 35.3-48.3 35-13.1-.2-25.8-3.5-32-7.7l7.5-20.6zM219.3 285.6l13.9 254.1 28.5 6.6 77.2-56.1 82.8 78 85.6-38.8 52 85.1c0 .1-.1.3-.1.4l27.8 6.4 109.1-278.5-476.8-57.2z'
    />
    <path
      d='M481 396.3c0 28.9-23.4 52.4-52.4 52.4-28.9 0-52.4-23.4-52.4-52.4 0-28.9 23.4-52.4 52.4-52.4 29 .1 52.4 23.5 52.4 52.4'
      style={{
        fill: '#fbae17',
      }}
    />
    <defs>
      <path
        id='SVGID_1_'
        d='M310.3 355.3c-18.9 3-34.1 12.7-53.6 13.5 1.5 59.2 3.1 118.3 4.9 177.5l77.2-56.1 82.8 78 85.6-38.8 52 85.1c19.2-59.7 38.4-119.4 58-179-9.3-.9-21.5.8-34.5 2.5-27.7 3.7-58.5 7.3-69.1-15-6.2-13-3.3-25-18.4-32.3-4.6-2.2-9.8-3-15.2-3.1.5 2.9.7 5.8.7 8.9 0 28.9-23.4 52.4-52.4 52.4-28.3 0-51.3-22.4-52.3-50.5-13.5-1.7-24.8-6.7-30.8-18.2-7.7-14.7-12.4-25.4-28.1-25.4-1.8-.2-4.2 0-6.8.5'
      />
    </defs>
    <clipPath id='SVGID_00000136374982730757277230000006558506745832386706_'>
      <use
        xlinkHref='#SVGID_1_'
        style={{
          overflow: 'visible',
        }}
      />
    </clipPath>
    <linearGradient
      id='SVGID_00000171701639742758196330000003884508216608267922_'
      gradientUnits='userSpaceOnUse'
      x1={630.993}
      y1={942.772}
      x2={639.984}
      y2={942.772}
      gradientTransform='matrix(0 16.6503 16.6503 0 -15260.33 -10114.3)'
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00b39b',
        }}
      />
      <stop
        offset={0.071}
        style={{
          stopColor: '#00b39b',
        }}
      />
      <stop
        offset={0.222}
        style={{
          stopColor: '#00ad9a',
        }}
      />
      <stop
        offset={0.429}
        style={{
          stopColor: '#009b98',
        }}
      />
      <stop
        offset={0.669}
        style={{
          stopColor: '#007e94',
        }}
      />
      <stop
        offset={0.931}
        style={{
          stopColor: '#00568f',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#004a8e',
        }}
      />
    </linearGradient>
    <path
      style={{
        clipPath:
          'url(#SVGID_00000136374982730757277230000006558506745832386706_)',
        fill: 'url(#SVGID_00000171701639742758196330000003884508216608267922_)',
      }}
      d='M256.8 354.6h360.6v259.8H256.8z'
    />
    <path
      d='M428.7 448.7c28.9 0 52.4-23.4 52.4-52.4 0-3-.3-6-.8-8.9-11.1-.2-23 2.9-32.6 4-17.9 2.1-47.7 9.7-71.3 6.8 1 28.1 24 50.5 52.3 50.5'
      style={{
        fill: '#fff',
      }}
    />
    <path
      className='st4'
      d='M261.8 546.8c1.3 42.2 2.6 84.4 4 126.6 29-18.4 78.2-36.9 160-40.4-33.8-28.7-85.9-61.4-164-86.2M559.3 614.6C389.6 636.7 325.5 688 302.2 717.1c75.3-2.1 150.7-4.2 226-6.2 10.4-32.1 20.8-64.2 31.1-96.3'
    />
  </svg>
);
export default LogoDarkIcelandia;
